import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { Helmet } from "react-helmet";

export default function PartnershipPage() {

    const authCtx = useAuth();

    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad();

    return (
        <>
            <Helmet>
                <title>Partnership - Equibre</title>
                <meta name="description" content="Join our team to enjoy innovative & diverse work culture. We are always commited to provide values to our team members for their expertise." />
            </Helmet>
            <section className="page-header-section">
                <div className="inner">
                    <h1>Partnership</h1>
                    <p>Join with Us to Innovate, Collaborate, and Grow Together</p>
                </div>
            </section>
            <section className="roles-section">
                <div className="inner">
                    <a href="https://forms.gle/3a9VazSqVnyRfECn8" target="_blank" className="normal-link">Partnership application ↗</a>
                </div>
            </section>
            <section className="career-section">
                <div className="inner">
                    <div className="card-col">
                        <div className="card-row biig">
                            <div className="inner">
                                <div className="card-hdr">
                                    <div className="col">
                                        <h1>Mutual Growth and Success</h1>
                                        <p>We view our partners as an extension of our team. Together, we strive for mutual growth and success by leveraging each other’s strengths and expertise.</p>
                                    </div>
                                    <div className="col">
                                        <h1>Innovation and Excellence</h1>
                                        <p>Innovation is at the heart of everything we do. We continuously explore new technologies, methodologies, and design trends to ensure our solutions are cutting-edge.</p>
                                    </div>
                                    <div className="col">
                                        <h1>Transparency and Communication</h1>
                                        <p>Effective communication is key to any successful partnership. We prioritize transparency, keeping you informed and involved at every stage of the project</p>
                                    </div>
                                </div>
                                <div className="card-label">
                                    <p>OUR PHILOSOPHY</p>
                                </div>
                            </div>
                        </div>
                        <div className="card-row biig">
                            <div className="inner">
                                <div className="card-hdr">
                                    <div className="col">
                                        <h1>Expertise</h1>
                                        <p>Our team consists of seasoned experts in web development, desktop development, mobile app development, and more. We bring a wealth of knowledge and experience to the table, ensuring your project benefits from the best industry practices.</p>
                                    </div>
                                    <div className="col">
                                        <h1>Customized Solutions</h1>
                                        <p>Our customized solutions are tailored to meet your specific needs, objectives, and target audience. Whether you need a robust eCommerce platform, a sleek portfolio website, or a complex enterprise application, we’ve got you covered.</p>
                                    </div>
                                    <div className="col">
                                        <h1>Dedicated Support</h1>
                                        <p>Our commitment to our partners extends beyond project delivery. We provide ongoing support and maintenance to ensure your digital solutions remain secure, up-to-date, and fully functional.</p>
                                    </div>
                                </div>
                                <div className="card-label">
                                    <p>BENEFITS</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ContactListSection />
        </>
    );
}